<template>
  <div
    v-if="$vuetify.breakpoint.smAndDown && showBottom"
    class="mobile-bottom-nav"
    :style="{ direction: $vuetify.rtl ? 'rtl' : 'ltr' }"
  >
    <button
      type="button"
      :aria-label="$t('dashboard')"
      :class="[
        'mobile-bottom-nav__item',
        $route.path === '/dashboard' ? 'mobile-bottom-nav__item--active' : '',
      ]"
      @click="changeRoute('/dashboard')"
    >
      <v-icon>mdi-view-dashboard</v-icon>
      <span class="mobile-bottom-nav__label">{{ $t("dashboard") }}</span>
    </button>
    <button
      type="button"
      :aria-label="$t('devices')"
      :class="[
        'mobile-bottom-nav__item',
        $route.path === '/devices' ? 'mobile-bottom-nav__item--active' : '',
      ]"
      @click="changeRoute('/devices')"
    >
      <v-icon>mdi-router-wireless</v-icon>
      <span class="mobile-bottom-nav__label">{{ $t("devices") }}</span>
    </button>
    <button
      type="button"
      :aria-label="$t('links.groups')"
      :class="[
        'mobile-bottom-nav__item',
        $route.path.startsWith('/groups')
          ? 'mobile-bottom-nav__item--active'
          : '',
      ]"
      @click="changeRoute('/groups')"
    >
      <v-icon>mdi-folder-multiple-outline</v-icon>
      <span class="mobile-bottom-nav__label">{{ $t("links.groups") }}</span>
    </button>
    <button
      type="button"
      :aria-label="$t('links.map')"
      :class="[
        'mobile-bottom-nav__item',
        $route.path === '/map' ? 'mobile-bottom-nav__item--active' : '',
      ]"
      @click="changeRoute('/map')"
    >
      <v-icon>mdi-map-outline</v-icon>
      <span class="mobile-bottom-nav__label">{{ $t("links.map") }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "MobileBottomNav",
  computed: {
    showBottom() {
      return true;
    },
  },
  methods: {
    changeRoute(path) {
      if (this.$router.history.current.path != path) {
        this.$router.push(path);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.mobile-bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  box-sizing: border-box;
  height: var(--sq-mobile-bottom-nav-height, 54px);
  padding: 4px 6px calc(4px + env(safe-area-inset-bottom));
  background: rgba(255, 255, 255, 0.98);
  border-top: 1px solid #e3e5ea;
  box-shadow: 0 -6px 16px rgba(17, 24, 39, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-around;
  direction: rtl;
}

.mobile-bottom-nav__item {
  appearance: none;
  border: 0;
  background: transparent;
  min-width: 44px;
  padding: 2px;
  color: #6d6e75;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font: inherit;
  line-height: 1;
}

.mobile-bottom-nav__item .v-icon {
  color: currentColor;
  font-size: 26px;
}

.mobile-bottom-nav__label {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.mobile-bottom-nav__item--active {
  color: #7a00cc;
}

.mobile-bottom-nav__item--active::before {
  content: "";
  position: absolute;
  top: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 16px;
  height: 3px;
  border-radius: 999px;
  background: currentColor;
}

.mobile-bottom-nav__item--active .v-icon {
  color: #7a00cc;
}

@media (max-width: 360px) {
  .mobile-bottom-nav {
    height: calc(52px + var(--sq-safe-area-bottom, 0px));
    padding-left: 4px;
    padding-right: 4px;
  }

  .mobile-bottom-nav__item {
    min-width: 40px;
  }

  .mobile-bottom-nav__item .v-icon {
    font-size: 24px;
  }
}

@media screen and (min-width: 960px) {
  .mobile-bottom-nav {
    display: none !important;
  }
}
</style>
